const nextIndentation = (list, index) => {
  if (list[index + 1] === undefined) {
    return 0;
  }

  return list[index + 1].indentation;
};

export const addNextIndentation = (tree) => tree.map((item, index) => ({
  ...item,
  nextIndentation: nextIndentation(tree, index),
}));
